import { REQUEST, SUCCESS, FAILURE } from 'redux-config/reduxHelpers';
import * as ActionTypes from '../actions';

const initialState = { isTaskStatusChanging: false };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CHANGE_REASSIGN_TASK_STATUS[REQUEST]:
      return {
        ...state,
        isTaskStatusChanging: true,
      };

    case ActionTypes.CHANGE_REASSIGN_TASK_STATUS[SUCCESS]:
      return {
        ...state,
        isTaskStatusChanging: false,
      };

    case ActionTypes.CHANGE_REASSIGN_TASK_STATUS[FAILURE]:
      return {
        ...state,
        isTaskStatusChanging: false,
      };

    default:
      return state;
  }
};

export default reducer;
